import styled from '@emotion/styled/macro';

export const PageStyled = styled.div`
    padding-bottom: 1rem;
    height: 100%;
`;
